/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */
import {BaseModule} from './BaseModule';
/**
 * Aangepast aan TS en wat wijzigingen
 * Jelmer Jellema - Spin in het Web - 5-2024
 */
export class Resize extends BaseModule {
  boxes: HTMLDivElement[] = [];
  dragBox!: HTMLDivElement;
  dragStartX!: number;
  preDragWidth!: number;
  override onCreate() {
    super.onCreate();
    this.addBox('nwse-resize');
    this.addBox('nesw-resize');
    this.addBox('nwse-resize');
    this.addBox('nesw-resize');
    this.positionBoxes();
  }
  override onDestroy() {
    this.setCursor('');
  }
  positionBoxes() {
    const handleStyles = this.options.handleStyles || {};
    const handleXOffset = `${-parseFloat(handleStyles.width as string || '0') / 2}px`;
    const handleYOffset = `${-parseFloat(handleStyles.height as string || '0') / 2}px`;
    [
      {left: handleXOffset, top: handleYOffset},
      {right: handleXOffset, top: handleYOffset},
      {right: handleXOffset, bottom: handleYOffset},
      {left: handleXOffset, bottom: handleYOffset},
    ].forEach((pos, idx) => {
      Object.assign(this.boxes[idx].style, pos);
    });
  };
  addBox(cursor: string) {
    const box = document.createElement('div');
    const handleStyles = this.options.handleStyles || {};
    Object.assign(box.style, handleStyles);
    box.style.cursor = cursor;
    box.style.width = `${handleStyles.width}px`;
    box.style.height = `${handleStyles.height}px`;
    box.addEventListener('mousedown', this.handleMousedown, false);
    if (this.resizer.overlay) {
      this.resizer.overlay.appendChild(box);
    }
    this.boxes.push(box);
  }
  handleMousedown = (evt: MouseEvent) => {
    this.dragBox = evt.target as HTMLDivElement;
    this.dragStartX = evt.clientX;
    this.preDragWidth = this.resizer.img?.width || this.resizer.img?.naturalWidth || 0;
    this.setCursor(this.dragBox.style.cursor);
    document.addEventListener('mousemove', this.handleDrag, false);
    document.addEventListener('mouseup', this.handleMouseup, false);
  }
  handleMouseup = () => {
    this.setCursor('');
    document.removeEventListener('mousemove', this.handleDrag);
    document.removeEventListener('mouseup', this.handleMouseup);
  }
  handleDrag = (evt: MouseEvent) => {
    if (!this.resizer.img) {
      return;
    }
    const deltaX = evt.clientX - this.dragStartX;
    if (this.dragBox === this.boxes[0] || this.dragBox === this.boxes[3]) {
      this.resizer.img.width = Math.round(this.preDragWidth - deltaX);
    } else {
      this.resizer.img.width = Math.round(this.preDragWidth + deltaX);
    }
    this.resizer.onUpdate();
  }
  setCursor(value: string) {
    [
      document.body,
      this.resizer.img,
    ].forEach((el) => {
      if (el) {
        el.style.cursor = value;
      }
    });
  };
}
